import { render } from "./UpdateQuiz.vue?vue&type=template&id=6e2981ff&scoped=true"
import script from "./UpdateQuiz.vue?vue&type=script&lang=js"
export * from "./UpdateQuiz.vue?vue&type=script&lang=js"

import "./UpdateQuiz.vue?vue&type=style&index=0&id=6e2981ff&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2981ff"]])

export default __exports__